import { render, staticRenderFns } from "./CustomerCustomerEmailTable.vue?vue&type=template&id=ed480674&scoped=true"
import script from "./CustomerCustomerEmailTable.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerEmailTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerCustomerEmailTable.vue?vue&type=style&index=0&id=ed480674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed480674",
  null
  
)

export default component.exports